import React from "react";

const Avatar = () => {
  return (
    <div className="hidden xl:flex xl:max-w-none">
      <img
        src="https://i.postimg.cc/jSHbqf06/avatar.png"
        height={"678px"}
        width={"737px"}
        alt=""
        className="translate-z-0 w-full h-full"
      />
    </div>
  );
};

export default Avatar;
